import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class AccountingStore {
	searchText: string = "";
}
